import "./popularCurrencies.scss";

import CurrencyCard from "../CurrencyCard";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "jalali-moment";

import popularCurTitle from "../../assets/icons/icones moj-02.svg";
import whitePopularCurTitle from "../../assets/icons/icones moj-22.svg";
import Spinner from "../Spinner";

const PopularCurrencies = ({ currencies, isLoading }) => {
  const [jalali, setJalali] = useState("");
  const popularCurrencies = currencies?.filter(
    (cur) =>
      cur.CurrencyId === 1 ||
      cur.CurrencyId === 3 ||
      cur.CurrencyId === 5 ||
      cur.CurrencyId === 21
  );

  const sortedPopularCurrencies = popularCurrencies
    .slice()
    .sort((a, b) => a.id - b.id);

  // store
  const darkThemeFromStore = useSelector(
    (state) =>
      // console.log(state);
      state.Reducer.darkTheme
  );

  useEffect(() => {
    const timeSortedCurs = popularCurrencies
      .slice()
      .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    moment.locale("fa", { useGregorianParser: true });
    setJalali(moment(timeSortedCurs[0]?.updatedAt).format("HH:mm YYYY/MM/DD"));
  }, [popularCurrencies]);

  return (
    <div
      className={`popular-currency-container ${
        isLoading ? "h-isloading" : ""
      } ${darkThemeFromStore ? "dark-back" : ""}`}
    >
      <div className="title">
        <img
          src={darkThemeFromStore ? whitePopularCurTitle : popularCurTitle}
          alt="ارز های پر مخاطب"
        />
        <h1>ارز های پر مخاطب</h1>
        <div className="latest-update mx-3 text-sm border-2 rounded-md px-1">{jalali}</div>
      </div>
      {isLoading ? (
        <Spinner isDark={true} />
      ) : (
        <div className="popular-currencies">
          {sortedPopularCurrencies?.map((cur) => {
            return (
              <CurrencyCard key={cur.id} isPopular={true} currency={cur} />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PopularCurrencies;
